import firebase from "firebase";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC_xx0zCexDjfHx6bJN4QGec2acUdR0ozY",
  authDomain: "slack-clone-debab.firebaseapp.com",
  projectId: "slack-clone-debab",
  storageBucket: "slack-clone-debab.appspot.com",
  messagingSenderId: "999960121485",
  appId: "1:999960121485:web:12e3a5ea82e7ed0dd692c4",
  measurementId: "G-MVWXK1ZKJ9",
};
const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
export default db;
